// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2M1f2","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1iKHF","obliqueLine":"membershipbadge_obliqueLine__1m8BX"};